<template>
  <div class="form-design">
    <!-- 表单预览区域 -->
    <div class="form-preview">
      <div class="form-preview-header">
        <span class="form-preview-title">表单预览</span>
        <el-button type="primary"
                   size="mini"
                   icon="el-icon-brush"
                   round
                   @click="openDesigner">开始设计</el-button>
      </div>
      <div class="form-preview-content">
        <div class="preview-content-wrap">
          <template v-if="formRule && formRule.length">
            <AppScrollbar style="height: 100%">
              <div class="preview-content">
                <form-create ref="formCreate"
                             :rule="formRule"
                             :option="formOption"
                             @submit="onFormSubmit" />
              </div>
            </AppScrollbar>
          </template>
          <template v-else>
            <div class="form-preview-empty">
              <span>请点击"开始设计"按钮进行设计</span>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- 设计弹窗 -->
    <DataGridDialog :visible.sync="designerVisible"
                    title="表单设计"
                    use-fullscreen
                    width="90%"
                    custom-class="form-designer-dialog"
                    @open="onDesignerOpen">
      <div class="designer-container">
        <FormDesigner ref="designer"
                      @hook:mounted="onDesignerOpen" />
      </div>
      <template slot="footer">
        <el-button @click="designerVisible = false">关闭窗口</el-button>
        <el-button type="primary"
                   @click="finishDesign">完成设计</el-button>
      </template>
    </DataGridDialog>
  </div>
</template>

<script>
import AppScrollbar from '../../AppScrollbar'
import FormDesigner from '../../form/FormDesigner'
import DataGridDialog from '../../grid/DataGridDialog'

export default {
  name: 'FormDesign',
  inject: ['$workflow'],
  components: {
    AppScrollbar,
    FormDesigner,
    DataGridDialog
  },
  data () {
    return {
      designerVisible: false,
    }
  },
  computed: {
    form () {
      return this.$workflow.design.form
    },
    formRule () {
      return this.form.rule || []
    },
    formOption () {
      return this.form.option || {}
    }
  },
  methods: {
    openDesigner () {
      this.designerVisible = true
    },
    onDesignerOpen () {
      this.$nextTick(() => {
        if (this.$refs.designer && this.formRule && this.formRule.length) {
          this.$refs.designer.setRule(this.formRule)
          this.$refs.designer.setOption(this.formOption)
        }
      })
    },
    finishDesign () {
      this.$nextTick(() => {
        if (this.$refs.designer) {
          this.$set(this.form, 'rule', this.$refs.designer.getRule())
          this.$set(this.form, 'option', this.$refs.designer.getOption())
          this.designerVisible = false
        }
      })
    },
    validate () {
      if (this.formRule && this.formRule.length) {
        return []
      }
      return ['表单中未添加任何组件']
    },
    onFormSubmit (formData) {
      this.$msgbox({
        title: '表单提交结果',
        confirmButtonText: '确定',
        customClass: 'form-submit-result-dialog',
        showCancelButton: false,
        closeOnClickModal: false,
        dangerouslyUseHTMLString: true,
        message: `<pre style="max-height: 400px; overflow: auto; background: #f5f7fa; padding: 12px; border-radius: 4px; font-size: 13px;">${JSON.stringify(formData, null, 2)}</pre>`
      })
    }
  }
}
</script>

<style lang="scss">
.form-design {
  height: 100%;
  display: flex;
  flex-direction: column;

  .form-preview {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .form-preview-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 16px;
      background: #f5f7fa;
      border-bottom: 1px solid #ebeef5;

      .form-preview-title {
        font-size: 14px;
        font-weight: 500;
        color: #303133;
      }
    }

    .form-preview-content {
      flex: auto;
      position: relative;

      &>.preview-content-wrap {
        position: absolute;
        inset: 0;

        .preview-content {
          padding: 16px;
        }
      }
    }

    .form-preview-empty {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 200px;
      color: #909399;
      font-size: 14px;
    }
  }
}
.el-message-box {
  &.form-submit-result-dialog {
    min-width: 320px;
  }
}
.el-dialog {
  &.form-designer-dialog {
    margin-top: 10vh!important;
    .el-dialog__body {
      padding: 0;
      height: 70vh;
    }

    .designer-container {
      position: absolute;
      inset: 0;

      ._fc-designer {
        height: 100%;
      }
    }
  }
}
</style>
